import { Resource } from "../resource/resource.model";

/**
 * Preference Frequency Model
 */

export class PreferenceFrequency extends Resource {
    name: string;
    code: string;
    description: string;
    status: string;
    tenantId: string;
}